import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=0f170b25&"
import script from "./ResultsPage.vue?vue&type=script&lang=js&"
export * from "./ResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f170b25')) {
      api.createRecord('0f170b25', component.options)
    } else {
      api.reload('0f170b25', component.options)
    }
    module.hot.accept("./ResultsPage.vue?vue&type=template&id=0f170b25&", function () {
      api.rerender('0f170b25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResultsPage.vue"
export default component.exports